const accountingWebsocketActionsConstants = Object.freeze({
  AGENT_SUGGESTION_UPDATED: 'agent_suggestion_updated',
  M3G_SYNC_COMPLETED: 'm3g_sync_completed',
  M3G_SYNC_FAILED: 'm3g_sync_failed',
  JE_MOVED_TO_REVIEW: 'je_moved_to_review',
});

const accountingWebsocketEntityTypeConstants = Object.freeze({
  JOURNAL_ENTRY: 'journal_entry',
  INVOICE: 'invoice',
  VENDOR: 'vendor',
});

const websocketActionsConstants = Object.freeze({
  PING: 'ping',
  PONG: 'pong',
});

const agentWebsocketActionsConstants = Object.freeze({
  NEW_CHAT: 'new_chat',
  CONTINUE_CHAT: 'continue_chat',
  CONFIRM: 'confirm',
  FILL_MISSING_INFO: 'fill_missing_info',
});

const agentWebsocketFlowConstants = Object.freeze({
  EXPENSE_ANALYSIS: 'expense-analysis',
  EXPENSE_SUBMISSION: 'expense-submission-with-data',
  MILEAGE_EXPENSE_SUBMISSION: 'mileage-expense-submission',
  MISSING_INFO: 'missing-info',
  PROCUREMENT_REQUEST: 'procurement-request',
});

const openBankingWebsocketActionsConstants = Object.freeze({
  CONNECTION_ACTIVE: 'connectionActive',
  REFRESH_ACCOUNTS_DONE: 'refreshAccountsDone',
});

const backendWebsocketActionsConstants = Object.freeze({
  AUTH: 'auth',
  BUDGET_REQUEST_SUBMITTED: 'budget_request_submitted',
  CARD_ACTIVATE: 'card_activate',
  CARD_CREATE: 'card_create',
  CARD_CREATE_ERROR: 'card_create_error',
  EXPENSE_APPROVAL_RESULT: 'expense_approval_result',
  EXPENSE_DUPLICATE_GROUP_UPDATE: 'expense_duplicate_group_update',
  EXPENSE_FILL_MISSING_INFO: 'expense_fill_missing_info',
  EXPENSE_PROCESSING_FINISHED: 'expense_processing_finished',
  EXPENSE_SUBMITTED: 'expense_submitted',
  EXPENSE_UPDATED: 'expense_updated',
  INVOICE_PROCESSING_FINISHED: 'invoice_processing_finished',
  NOTIFICATION_COUNTER_UPDATE: 'notification_counter_update',
  // Action name not confirmed with the backend yet (the ticket only names the `payout.update` event).
  PAYOUT_UPDATE: 'payout_update',
  PO_APPROVERS_ASSIGNED: 'po_approvers_assigned',
  VENDOR_CREATE_COMPLETED: 'vendor_create_completed',
  VENDOR_CREATE_ERROR: 'vendor_create_error',
});

const bankingWebsocketActionsConstants = Object.freeze({
  AUTH: 'auth',
  // enroll actions
  KEYLESS_ENROLL: 'keylessEnroll',
  KEYLESS_ENROLLMENT_SUCCESS: 'keylessEnrollmentSuccess',
  KEYLESS_ENROLLMENT_FAILURE: 'keylessEnrollmentFailure',
  KEYLESS_ENROLL_SMS_VERIFICATION_FAILURE: 'keylessEnrollSMSVerificationFailure',
  // authenticate actions
  KEYLESS_AUTHENTICATE: 'keylessAuthenticate',
  KEYLESS_AUTHENTICATE_SUCCESS: 'keylessChallengeAuthenticationSuccess',
  KEYLESS_AUTHENTICATE_FAILED: 'keylessChallengeAuthenticationFailed'
});

export {
  websocketActionsConstants,
  accountingWebsocketActionsConstants,
  accountingWebsocketEntityTypeConstants,
  agentWebsocketActionsConstants,
  agentWebsocketFlowConstants,
  backendWebsocketActionsConstants,
  bankingWebsocketActionsConstants,
  openBankingWebsocketActionsConstants,
};
